export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_ORDER_FIELD = "id";
export const ASC = "asc";
export const DESC = "desc";
